export default {"src":"/_next/static/media/grow.92642cfd.svg","height":28,"width":28};